'use client';
import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { initializeApp } from '../../redux/core/thunks.js';
import { useAppDispatch } from '../../redux/hooks.js';
import { sourceDataActions } from '../../redux/core/sourceData/sourceDataSlice.js';
import { InlineFormWrapper } from '../../redux/wrappers/InlineForm/index.js';
import { inlineFormActions } from '../../redux/wrappers/InlineForm/inlineFormSlice.js';
import { store } from '../../redux/index.js';
import { setActiveView, setActiveWrapper, WRAPPER_TYPES, } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const InlineForm = (props) => {
    const { params } = props;
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(initializeApp(props));
        dispatch(setActiveWrapper('inlineForm'));
        dispatch(setActiveWrapper(WRAPPER_TYPES.INLINE_FORM));
        dispatch(sourceDataActions.updateLoginSource(params.loginSource));
        dispatch(sourceDataActions.updateRedirectionUrl(params.redirectionUrl));
        dispatch(inlineFormActions.changeForm(params.formType));
        dispatch(setActiveView(params.formType));
        params.onLoginSuccess &&
            dispatch(sourceDataActions.updateCallbackFunction(params.onLoginSuccess));
    });
    return (_jsx(InlineFormWrapper, { formType: params.formType, encodedGTLibraryUrl: params.encodedGTLibraryUrl }));
};
// Wrap with Redux Provider directly instead of using withReduxProvider HOC
// This avoids circular dependency issues since the store() call happens at
// render time, not at module load time
export const InlineFormContainer = (props) => {
    return (_jsx(Provider, { store: store(), children: _jsx(InlineForm, { ...props }) }));
};
//# sourceMappingURL=InlineForm.js.map